import AddRoundedIcon from '@mui/icons-material/AddRounded';
import CancelIcon from '@mui/icons-material/Cancel';
import { IconButton, TableRow } from '@mui/material';
import CustomTableCell from 'components/CustomTableCell';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

interface PackageTransactionProps {
  transaction: any;
  onCancel?: (transactionId: string) => void;
  isAdmin?: boolean;
}

const PackageTransaction = ({ transaction, onCancel, isAdmin }: PackageTransactionProps) => {
  const { t } = useTranslation();
  const isCredit = transaction.type !== 'DEBIT';
  
  const formatMessage = (transaction: any) => {
    if (!isCredit) return '';
    const planTitle = transaction.plan_title;
    // If plan_title looks like a translation key (starts with PACKAGE_), translate it
    if (planTitle && planTitle.startsWith('PACKAGE_')) {
      return ` ${t(planTitle)}`;
    }
    return ` ${planTitle}`;
  };

  // Determine package status: cancelled, active, or inactive
  const getPackageStatus = () => {
    if (transaction.status === 'cancelled') {
      return t('PACKAGE_STATUS_CANCELLED');
    }
    const isActive = transaction.status === 'success' && 
                     transaction.expiry_date && 
                     new Date(transaction.expiry_date) > new Date();
    return isActive ? t('PACKAGE_STATUS_ACTIVE') : t('PACKAGE_STATUS_INACTIVE');
  };

  return (
    <TableRow
      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
    >
      <CustomTableCell clickable={false} align='center' width={"100px"}>
        {isCredit ? <AddRoundedIcon sx={{mr:2}}/> : null}
      </CustomTableCell>
      <CustomTableCell clickable={false} width={"180px"}>
        {moment.utc(transaction.createdAt).local().format('DD/MM/YY')}{' '}
        <span className='table-time'>
          {moment.utc(transaction.createdAt).local().format('HH:mm')}
        </span>
      </CustomTableCell>
      <CustomTableCell clickable={false} width={"180px"}>
        {isCredit ? formatMessage(transaction) : ''}
      </CustomTableCell>
      <CustomTableCell clickable={false} width={"180px"}>
        {isCredit && transaction.unlimited && transaction.expiry_date ? 
          moment.utc(transaction.expiry_date).local().format('DD/MM/YY') : 
          ''
        }
      </CustomTableCell>
      <CustomTableCell clickable={false} width={"180px"}>
        {getPackageStatus()}
      </CustomTableCell>
      <CustomTableCell clickable={false} width={"180px"}>
        {transaction.status === 'cancelled' && transaction.cancellationReason
          ? transaction.cancellationReason
          : '-'}
      </CustomTableCell>
      {isAdmin && <CustomTableCell clickable={false} width={"100px"} align="center">
         {isCredit && transaction.unlimited && transaction.status === 'success' && 
          transaction.expiry_date && new Date(transaction.expiry_date) > new Date() && 
          onCancel ? (
          <IconButton 
            size="small" 
            onClick={() => onCancel(transaction.id)}
            color="error"
          >
            <CancelIcon />
          </IconButton>
        ) : null}
      </CustomTableCell>
      }
    </TableRow>
  );
};

export default PackageTransaction;
